module.exports = __webpack_public_path__ + "img/Photo-Oct-03,-4-05-23-PM.b2ea30a5.jpg";